import React from "react";
import { Box, Typography } from "@mui/material";

const StatusTag = ({ status }) => {
  const bgColor = status === "ACTIVE" ? "success.light" : "error.light";
  const textColor = status === "ACTIVE" ? "success.dark" : "error.dark";

  return (
    <Box
      component="span"
      sx={{
        px: 1, // Padding horizontal
        py: 0.5, // Padding vertical
        borderRadius: "12px", // Rounded corners
        fontSize: "0.8em",
        fontWeight: "bold",
        bgcolor: bgColor,
        color: textColor,
        display: "inline-block", // Ensure padding applies correctly
      }}
    >
      <Typography variant="caption" sx={{ fontWeight: "bold", color: "#fff" }}>
        {status}
      </Typography>
    </Box>
  );
};

export default StatusTag;
